import * as React from "react";
import PropTypes from "prop-types";
import MountOnBody from "nx-components/MountOnBody";
import Environment from "nexia_mobile/environment";
import Location from "nexia_mobile/models/location";
import Collection from "nexia_mobile/framework/collection";
import AppBarWrapper from "nexia_mobile/components/TopBar/AppBarWrapper";
import CommonAppBarContainer from "nexia_mobile/components/TopBar/CommonAppBarContainer";
import Device from "nexia_mobile/models/device";
import GroupFeature from "nexia_mobile/models/mixins/device_features/group";
import ThermostatFeature from "nexia_mobile/models/mixins/device_features/thermostat";
import BackboneListener from "nexia_mobile/components/BackboneListener";
import NoDevicesPageCommercial from "nexia_mobile/components/Commercial/NoDevicesPageCommercial";
import NoDevicesPage from "nexia_mobile/components/Pages/NoDevicesPage";
import DeviceDetails from "nexia_mobile/components/Details/DeviceDetails";
import DashboardTilesPage from "nexia_mobile/components/Pages/DashboardTilesPage";
import Page from "nexia_mobile/components/Page";
import SpinnerOverlay from "nexia_mobile/components/SpinnerOverlay";
import DeviceSorter from "nexia_mobile/models/device_sorter";

function shouldViewItemDetails(item) {
  // Don't go to the GroupDetailsPage. Groups which are thermostats are multi-zoned
  // so that page is allowed.
  return (
    item instanceof Device &&
    (!item.hasFeature(GroupFeature) || item.hasFeature(ThermostatFeature))
  );
}

export default class DashboardPage extends React.Component {
  static propTypes = {
    currentLocation: PropTypes.instanceOf(Location).isRequired,
    showDeviceAdd: PropTypes.func.isRequired, // () => void
  };

  _loadTileItems = () => {
    const { currentLocation } = this.props;
    const devices = currentLocation.get("devices");

    const models = [];
    devices.each((device) => models.push(device));

    const sortedModels = DeviceSorter.sort(models);
    if (this._tileItems) {
      this._tileItems.set(sortedModels);
    } else {
      this._tileItems = new Collection(sortedModels);
    }

    return this._tileItems;
  };

  render() {
    const { currentLocation, showDeviceAdd } = this.props;

    return (
      <BackboneListener
        listenTo={currentLocation}
        events={[
          "change:hasParsedChildCollections",
          "change:hasGroupSaveUpdates",
        ]}
      >
        {() => {
          const automations = currentLocation.get("automations");
          const devices = currentLocation.get("devices");

          return (
            <BackboneListener
              listenTo={automations}
              events={[
                "add",
                "remove",
                "reset",
                "sort",
                "change:shownOnDashboard",
              ]}
              debounceRender
            >
              {() => (
                <BackboneListener
                  listenTo={devices}
                  events={["reset", "sort", "update"]}
                >
                  {() => {
                    const isCommercial = Environment.isCommercial();

                    const locationAppBar = (
                      <AppBarWrapper>
                        <CommonAppBarContainer
                          title={currentLocation.get("name")}
                        />
                      </AppBarWrapper>
                    );

                    if (!currentLocation.get("hasParsedChildCollections")) {
                      return (
                        <Page name="UnparsedSpinner" fullyLoaded={false}>
                          {locationAppBar}
                          <MountOnBody>
                            <SpinnerOverlay />
                          </MountOnBody>
                        </Page>
                      );
                    }

                    const tileItems = this._loadTileItems();
                    if (tileItems.length === 0) {
                      return isCommercial ? (
                        <NoDevicesPageCommercial
                          appBar={locationAppBar}
                          title={currentLocation.get("name")}
                          showDeviceAdd={showDeviceAdd}
                        />
                      ) : (
                        <NoDevicesPage
                          appBar={locationAppBar}
                          showDeviceAdd={showDeviceAdd}
                        />
                      );
                    } else if (
                      tileItems.length === 1 &&
                      shouldViewItemDetails(tileItems.first())
                    ) {
                      return (
                        <DeviceDetails
                          model={tileItems.first()}
                          appBar={locationAppBar}
                          isDashboard
                        />
                      );
                    }

                    return (
                      <DashboardTilesPage
                        appBar={locationAppBar}
                        location={currentLocation}
                        tileItems={tileItems}
                      />
                    );
                  }}
                </BackboneListener>
              )}
            </BackboneListener>
          );
        }}
      </BackboneListener>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/DashboardPage.jsx